import React from 'react';

import './NormalComponent.css'


const NormalComponent = (props) => {
  const { children } = props

  return (
    <div className="normal-component">
      <div className="component-elem">
        {children}
      </div>
    </div>
  )
}

export default NormalComponent